(() => {
  const roots = document.querySelectorAll('[data-ring-builder]');
  if (!roots.length) return;

  const METALS = [
    '14K Yellow Gold', '14K White Gold', '14K Rose Gold',
    '18K Yellow Gold', '18K White Gold', '18K Rose Gold',
    '14K Two Tone', '18K Two Tone', 'Platinum'
  ];
  const PURITIES = ['14K', '18K', 'Platinum'];
  const METAL_COLORS = ['Yellow', 'White', 'Rose', 'Two Tone'];
  const METAL_FACTORS = {
    '14K Yellow Gold': 1, '14K White Gold': 1.02, '14K Rose Gold': 1.03,
    '18K Yellow Gold': 1.18, '18K White Gold': 1.2, '18K Rose Gold': 1.21,
    '14K Two Tone': 1.12, '18K Two Tone': 1.3, Platinum: 1.38
  };
  const SHAPES = ['Oval', 'Round', 'Emerald', 'Radiant', 'Marquise', 'Cushion', 'Pear', 'Elongated Cushion', 'Princess', 'Asscher', 'Heart', 'Moval'];
  const CARATS = Array.from({ length: 17 }, (_, index) => (1 + index * 0.25).toFixed(2));
  const COLORS = ['D', 'E', 'F', 'G', 'H', 'I', 'J'];
  const CLARITIES = ['FL', 'IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2'];
  const CUTS = ['Super Ideal', 'Ideal', 'Very Good', 'Good', 'Fair'];
  const ORIGINS = ['Lab-Grown', 'Natural'];
  const PAGE_SIZE = 24;
  const MISSING_GALLERY_FILES = new Set([
    '486612N-14KY-14KW-three.jpg',
    '486760C-14KW-two.jpg',
    '536095J-14KY-14KW-three.jpg'
  ]);

  const money = value => new Intl.NumberFormat('en-US', {
    style: 'currency', currency: 'USD', maximumFractionDigits: 0
  }).format(Math.round(value / 25) * 25);
  const handle = value => value.toLowerCase().replace(/é/g, 'e').replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

  roots.forEach(root => {
    const catalogNode = root.querySelector('[data-ring-builder-catalog]');
    if (!catalogNode) return;

    const settings = JSON.parse(catalogNode.textContent);
    const ringBase = root.dataset.ringFileBase || '';
    const stoneBase = root.dataset.stoneFileBase || '';
    const galleries = typeof settingVariantGalleries !== 'undefined' ? settingVariantGalleries : {};
    const customSetting = {
      id: 'custom',
      name: 'Custom Engagement Ring',
      category: 'custom',
      detail: 'Created one-on-one around your inspiration',
      price: 0,
      imageStyle: 'solitaire',
      settingDiamonds: true,
      shapes: SHAPES,
      custom: true
    };
    const state = {
      path: 'setting',
      stage: 'landing',
      setting: null,
      settingDraft: null,
      diamond: null,
      diamondDraft: null,
      settingFilters: { category: 'all', purity: 'all', color: 'all', shape: 'all' },
      diamondFilters: { origin: 'Lab-Grown', shape: 'all', carat: 'all', color: 'all', clarity: 'all', cut: 'all' },
      page: 1,
      sort: 'recommended',
      cardChoices: {}
    };

    const q = selector => root.querySelector(selector);
    const qa = selector => [...root.querySelectorAll(selector)];
    const title = q('[data-page-title]');
    const subtitle = q('[data-page-subtitle]');
    const defaultTitle = title.textContent;
    const defaultSubtitle = subtitle.textContent;

    const metalColor = metal => {
      if (metal.includes('White') || metal === 'Platinum') return 'white';
      if (metal.includes('Rose')) return 'rose';
      return 'yellow';
    };
    const splitMetal = metal => {
      if (metal === 'Platinum') return { purity: 'Platinum', color: 'White' };
      return {
        purity: metal.startsWith('18K') ? '18K' : '14K',
        color: metal.includes('Two Tone') ? 'Two Tone' : metal.includes('White') ? 'White' : metal.includes('Rose') ? 'Rose' : 'Yellow'
      };
    };
    const combineMetal = (purity, color) => {
      if (purity === 'Platinum') return 'Platinum';
      return `${purity} ${color === 'Two Tone' ? 'Two Tone' : `${color} Gold`}`;
    };
    const metalColorsForPurity = purity => purity === 'Platinum' ? ['White'] : METAL_COLORS;
    const catalogMetalsForPurity = purity => METALS.filter(metal => splitMetal(metal).purity === purity);
    const imageShape = shape => {
      if (shape === 'Moval') return 'oval';
      if (shape === 'Elongated Cushion') return 'cushion';
      return handle(shape);
    };
    const ringUrl = (setting, shape, metal) =>
      `${ringBase}ring-builder-${imageShape(shape)}-${setting.imageStyle}-${metalColor(metal)}.webp`;
    const fallbackUrl = (shape, metal) =>
      `${ringBase}ring-builder-${imageShape(shape)}-solitaire-${metalColor(metal)}.webp`;
    const stoneIconUrl = shape => {
      if (shape === 'Moval' || shape === 'Elongated Cushion') return `${stoneBase}ta-ring-builder-stone-elongated-cushion.webp`;
      return `${stoneBase}ta-ring-builder-stone-${handle(shape)}.webp`;
    };
    const galleryUrls = (setting, shape, metal) => {
      const styleGallery = galleries[setting.id] || {};
      const shapeGallery = styleGallery[shape] || styleGallery[setting.shapes[0]] || Object.values(styleGallery)[0] || {};
      const images = shapeGallery[metal] || shapeGallery['14K Yellow Gold'] || Object.values(shapeGallery)[0] || [];
      return images
        .map(url => url.split('/').pop().split('?')[0])
        .filter(filename => !MISSING_GALLERY_FILES.has(filename))
        .map(filename => `${ringBase}ta-rb-${filename}`);
    };
    const photoUrl = (setting, shape, metal, index = 0) =>
      galleryUrls(setting, shape, metal)[index] || ringUrl(setting, shape, metal);
    const attachImageFallback = image => {
      image.addEventListener('error', () => {
        if (image.dataset.fallback && image.src !== image.dataset.fallback) {
          image.src = image.dataset.fallback;
          return;
        }
        const finalFallback = `${ringBase}ring-builder-oval-solitaire-yellow.webp`;
        if (image.src !== finalFallback) image.src = finalFallback;
      });
    };

    const settingPrice = draft => {
      let price = draft.setting.price * METAL_FACTORS[draft.metal];
      if (draft.setting.settingDiamonds && draft.origin === 'Natural') price *= 1.5;
      return price;
    };
    const diamondPrice = diamond => {
      const shapeFactor = { Round: 1.12, Oval: 1, Emerald: .92, Radiant: .96, Marquise: .9, Cushion: .94, Pear: .91, 'Elongated Cushion': 1.02, Princess: .88, Asscher: .9, Heart: .98, Moval: 1.05 }[diamond.shape] || 1;
      const colorFactor = { D: 1.3, E: 1.2, F: 1.12, G: 1.04, H: .96, I: .88, J: .8 }[diamond.color];
      const clarityFactor = { FL: 1.45, IF: 1.35, VVS1: 1.25, VVS2: 1.17, VS1: 1.08, VS2: 1, SI1: .86, SI2: .72 }[diamond.clarity];
      const cutFactor = { 'Super Ideal': 1.16, Ideal: 1.08, 'Very Good': 1, Good: .91, Fair: .82 }[diamond.cut];
      const originFactor = diamond.origin === 'Natural' ? 4.6 : 1;
      return 900 * Math.pow(Number(diamond.carat), 1.68) * shapeFactor * colorFactor * clarityFactor * cutFactor * originFactor;
    };

    function setStage(stage) {
      state.stage = stage;
      q('[data-view="landing"]').hidden = stage !== 'landing';
      q('[data-view="experience"]').hidden = stage === 'landing';
      q('[data-start-over]').hidden = stage === 'landing';
      qa('[data-stage]').forEach(panel => { panel.hidden = panel.dataset.stage !== stage; });
      if (stage === 'landing') {
        title.textContent = defaultTitle;
        subtitle.textContent = defaultSubtitle;
        return;
      }

      const content = {
        'setting-catalog': ['Select Your Setting', 'Choose the design that frames your diamond and your vision.'],
        'setting-detail': ['Customize Your Setting', 'Choose the shape, metal and ring size that feel right.'],
        'diamond-catalog': ['Select Your Diamond', 'Compare representative diamond profiles and estimated prices.'],
        'diamond-detail': ['Review Your Diamond', 'Confirm the diamond profile you would like us to source.'],
        complete: ['Review Your Ring', 'A starting point for your one-on-one TA Jewelers consultation.']
      }[stage];
      title.textContent = content[0];
      subtitle.textContent = content[1];
      updateProgress();
      window.scrollTo({ top: Math.max(0, root.offsetTop - 20), behavior: 'smooth' });
    }

    function updateProgress() {
      const order = state.path === 'setting' ? ['setting', 'diamond', 'complete'] : ['diamond', 'setting', 'complete'];
      const currentKey = state.stage.startsWith('setting') ? 'setting' : state.stage.startsWith('diamond') ? 'diamond' : 'complete';
      qa('[data-go-step]').forEach(button => {
        const key = button.dataset.goStep;
        const number = order.indexOf(key) + 1;
        button.querySelector('span').textContent = number;
        button.classList.toggle('is-active', key === currentKey);
        button.classList.toggle('is-complete', (key === 'setting' && !!state.setting) || (key === 'diamond' && !!state.diamond));
        button.style.order = number;
      });
    }

    function start(path) {
      state.path = path;
      if (path === 'setting') {
        renderSettings();
        setStage('setting-catalog');
      } else {
        renderDiamonds();
        setStage('diamond-catalog');
      }
    }

    function cardChoice(setting) {
      if (!state.cardChoices[setting.id]) {
        state.cardChoices[setting.id] = {
          shape: state.settingFilters.shape !== 'all' && setting.shapes.includes(state.settingFilters.shape) ? state.settingFilters.shape : setting.shapes[0],
          metal: METALS[0]
        };
      }
      return state.cardChoices[setting.id];
    }

    function metalButton(metal, selected, labeled = false) {
      const colorClass = metalColor(metal);
      return `<button type="button" class="ring-builder__metal ${selected === metal ? 'is-selected' : ''}" data-metal="${metal}" title="${metal}" aria-label="${metal}">
        <i class="ring-builder__metal-dot ring-builder__metal-dot--${colorClass} ${metal.includes('Two Tone') ? 'ring-builder__metal-dot--two-tone' : ''}"></i>${labeled ? `<span>${metal}</span>` : ''}
      </button>`;
    }
    function shapeButton(shape, selected, labeled = false) {
      return `<button type="button" class="ring-builder__shape ${selected === shape ? 'is-selected' : ''}" data-shape="${shape}" title="${shape}" aria-label="${shape}">
        <img src="${stoneIconUrl(shape)}" alt="" loading="lazy">${labeled ? `<span>${shape}</span>` : ''}
      </button>`;
    }
    function colorButton(color, selected) {
      const colorClass = color === 'White' ? 'white' : color === 'Rose' ? 'rose' : 'yellow';
      return `<button type="button" class="ring-builder__metal ${selected === color ? 'is-selected' : ''}" data-color="${color}" title="${color}" aria-label="${color}">
        <i class="ring-builder__metal-dot ring-builder__metal-dot--${colorClass} ${color === 'Two Tone' ? 'ring-builder__metal-dot--two-tone' : ''}"></i><span>${color}</span>
      </button>`;
    }

    function renderSettings() {
      const filtered = settings.filter(setting => {
        if (state.settingFilters.category !== 'all' && setting.category !== state.settingFilters.category) return false;
        if (state.settingFilters.shape !== 'all' && !setting.shapes.includes(state.settingFilters.shape)) return false;
        return true;
      });
      q('[data-setting-count]').textContent = filtered.length;
      const grid = q('[data-setting-grid]');
      grid.innerHTML = filtered.map(setting => {
        const choice = cardChoice(setting);
        const current = splitMetal(choice.metal);
        let purity = state.settingFilters.purity !== 'all' ? state.settingFilters.purity : current.purity;
        let color = state.settingFilters.color !== 'all' ? state.settingFilters.color : current.color;
        if (purity === 'Platinum') color = 'White';
        if (color === 'Two Tone' && purity === 'Platinum') purity = '14K';
        choice.metal = combineMetal(purity, color);
        if (state.settingFilters.shape !== 'all') choice.shape = state.settingFilters.shape;
        const draft = { setting, ...choice, origin: 'Lab-Grown', size: '6.50' };
        const catalogMetals = catalogMetalsForPurity(purity);
        return `<article class="ring-builder__setting-card" data-setting-card="${setting.id}">
          <button class="ring-builder__card-open" type="button" data-open-setting="${setting.id}">
            <span class="ring-builder__card-image"><img src="${photoUrl(setting, choice.shape, choice.metal)}" data-fallback="${fallbackUrl(choice.shape, choice.metal)}" alt="${setting.name} in ${choice.metal} with a ${choice.shape} center" loading="lazy"></span>
            <span class="ring-builder__card-name">${setting.name}</span>
          </button>
          <p>${setting.detail}</p>
          <p><strong data-card-price>${money(settingPrice(draft))}</strong> setting estimate</p>
          <div class="ring-builder__card-metals" aria-label="Choose metal color">${catalogMetals.map(metal => metalButton(metal, choice.metal)).join('')}</div>
          <div class="ring-builder__card-shapes" aria-label="Choose center shape">${setting.shapes.map(shape => shapeButton(shape, choice.shape)).join('')}</div>
        </article>`;
      }).join('') + `
        <article class="ring-builder__custom-card">
          <span class="ring-builder__custom-card-mark" aria-hidden="true">+</span>
          <p class="ring-builder__eyebrow">Personal design service</p>
          <h2>Don’t see a style you love?</h2>
          <p>Let’s create a setting around your inspiration, preferred center shape, metal and details.</p>
          <button class="ring-builder__primary-button" type="button" data-open-custom-setting>
            Start a custom setting <span aria-hidden="true">→</span>
          </button>
        </article>`;
      qa('[data-setting-card] img[data-fallback]').forEach(attachImageFallback);
    }

    function updateCard(card, setting) {
      const choice = cardChoice(setting);
      const image = card.querySelector('.ring-builder__card-image img');
      image.dataset.fallback = fallbackUrl(choice.shape, choice.metal);
      image.src = photoUrl(setting, choice.shape, choice.metal);
      image.alt = `${setting.name} in ${choice.metal} with a ${choice.shape} center`;
      card.querySelectorAll('[data-metal]').forEach(button => button.classList.toggle('is-selected', button.dataset.metal === choice.metal));
      card.querySelectorAll('[data-shape]').forEach(button => button.classList.toggle('is-selected', button.dataset.shape === choice.shape));
      card.querySelector('[data-card-price]').textContent = money(settingPrice({ setting, ...choice, origin: 'Lab-Grown' }));
    }

    function openSetting(id) {
      const setting = settings.find(item => item.id === id);
      const choice = cardChoice(setting);
      state.settingDraft = {
        setting,
        shape: choice.shape,
        metal: choice.metal,
        origin: 'Lab-Grown',
        size: state.setting?.setting.id === id ? state.setting.size : '6.50',
        angle: 0
      };
      renderSettingDetail();
      setStage('setting-detail');
    }

    function openCustomSetting() {
      const filteredPurity = state.settingFilters.purity !== 'all' ? state.settingFilters.purity : '14K';
      const filteredColor = state.settingFilters.color !== 'all' ? state.settingFilters.color : 'Yellow';
      const purity = filteredColor === 'Two Tone' && filteredPurity === 'Platinum' ? '14K' : filteredPurity;
      const color = purity === 'Platinum' ? 'White' : filteredColor;
      state.settingDraft = {
        setting: customSetting,
        shape: state.settingFilters.shape !== 'all' ? state.settingFilters.shape : 'Oval',
        metal: combineMetal(purity, color),
        origin: 'Lab-Grown',
        size: state.setting?.setting.id === 'custom' ? state.setting.size : '6.50',
        customNotes: state.setting?.setting.id === 'custom' ? state.setting.customNotes : '',
        angle: 0
      };
      renderSettingDetail();
      setStage('setting-detail');
    }

    function renderSettingDetail() {
      const draft = state.settingDraft;
      q('[data-setting-detail-name]').textContent = draft.setting.name;
      q('[data-setting-detail-style]').textContent = draft.setting.detail;
      q('[data-setting-origin-wrap]').hidden = !draft.setting.settingDiamonds;
      q('[data-setting-detail-options="origin"]').innerHTML = ['Lab-Grown', 'Natural'].map(origin =>
        `<button type="button" data-origin="${origin}" class="${draft.origin === origin ? 'is-selected' : ''}">${origin}</button>`
      ).join('');
      q('[data-setting-detail-options="shape"]').innerHTML = draft.setting.shapes.map(shape => shapeButton(shape, draft.shape, true)).join('');
      const selectedMetal = splitMetal(draft.metal);
      q('[data-setting-detail-options="purity"]').innerHTML = PURITIES.map(purity =>
        `<button type="button" data-purity="${purity}" class="${selectedMetal.purity === purity ? 'is-selected' : ''}">${purity}</button>`
      ).join('');
      q('[data-setting-detail-options="color"]').innerHTML = metalColorsForPurity(selectedMetal.purity).map(color => colorButton(color, selectedMetal.color)).join('');
      q('[data-ring-size]').value = draft.size;
      q('[data-custom-setting-notes-wrap]').hidden = !draft.setting.custom;
      q('[data-custom-setting-notes]').value = draft.customNotes || '';
      q('[data-custom-setting-notes-error]').hidden = true;
      updateSettingDetail();
    }

    function updateSettingDetail() {
      const draft = state.settingDraft;
      const selectedMetal = splitMetal(draft.metal);
      const photos = galleryUrls(draft.setting, draft.shape, draft.metal);
      draft.angle = Math.min(draft.angle || 0, Math.max(0, photos.length - 1));
      const image = q('[data-setting-detail-image]');
      image.dataset.fallback = fallbackUrl(draft.shape, draft.metal);
      image.src = photos[draft.angle] || ringUrl(draft.setting, draft.shape, draft.metal);
      image.alt = `${draft.setting.name} in ${draft.metal} with a ${draft.shape} center`;
      if (!image.dataset.boundFallback) {
        attachImageFallback(image);
        image.dataset.boundFallback = 'true';
      }
      q('[data-setting-thumbnails]').innerHTML = photos.slice(0, 4).map((photo, index) =>
        `<button type="button" class="ring-builder__thumbnail ${draft.angle === index ? 'is-selected' : ''}" data-angle="${index}" aria-label="View angle ${index + 1}"><img src="${photo}" alt="" loading="lazy"></button>`
      ).join('');
      q('[data-setting-detail-price]').textContent = draft.setting.custom ? 'Custom quote' : money(settingPrice(draft));
      q('[data-setting-price-label]').textContent = draft.setting.custom ? 'pricing confirmed after consultation' : 'setting estimate';
      q('[data-selected-purity]').textContent = selectedMetal.purity;
      q('[data-selected-color]').textContent = selectedMetal.color;
      qa('[data-setting-detail-options] [data-purity]').forEach(button => button.classList.toggle('is-selected', button.dataset.purity === selectedMetal.purity));
      q('[data-setting-detail-options="color"]').innerHTML = metalColorsForPurity(selectedMetal.purity).map(color => colorButton(color, selectedMetal.color)).join('');
      qa('[data-setting-detail-options] [data-shape]').forEach(button => button.classList.toggle('is-selected', button.dataset.shape === draft.shape));
      qa('[data-setting-detail-options] [data-origin]').forEach(button => button.classList.toggle('is-selected', button.dataset.origin === draft.origin));
    }

    function diamondOptionValues(key) {
      const selected = state.diamondFilters[key];
      if (selected !== 'all') return [selected];
      return { origin: ORIGINS, shape: SHAPES, carat: CARATS, color: COLORS, clarity: CLARITIES, cut: CUTS }[key];
    }

    function diamondDimensions() {
      const dimensions = {
        origin: diamondOptionValues('origin'),
        shape: diamondOptionValues('shape'),
        carat: diamondOptionValues('carat'),
        color: diamondOptionValues('color'),
        clarity: diamondOptionValues('clarity'),
        cut: diamondOptionValues('cut')
      };
      if (state.sort === 'price-low') {
        dimensions.origin.sort((a, b) => ORIGINS.indexOf(a) - ORIGINS.indexOf(b));
        dimensions.carat.sort((a, b) => Number(a) - Number(b));
        dimensions.color.reverse(); dimensions.clarity.reverse(); dimensions.cut.reverse();
      } else if (state.sort === 'price-high') {
        dimensions.origin.sort((a, b) => ORIGINS.indexOf(b) - ORIGINS.indexOf(a));
        dimensions.carat.sort((a, b) => Number(b) - Number(a));
      } else if (state.sort === 'carat-high') {
        dimensions.carat.sort((a, b) => Number(b) - Number(a));
      }
      return dimensions;
    }

    function diamondAt(index, dimensions) {
      const keys = ['cut', 'clarity', 'color', 'carat', 'shape', 'origin'];
      const result = {};
      keys.forEach(key => {
        const values = dimensions[key];
        result[key] = values[index % values.length];
        index = Math.floor(index / values.length);
      });
      result.id = [result.origin, result.shape, result.carat, result.color, result.clarity, result.cut].map(handle).join('-');
      result.price = diamondPrice(result);
      return result;
    }

    function renderDiamonds() {
      const dimensions = diamondDimensions();
      const total = Object.values(dimensions).reduce((product, values) => product * values.length, 1);
      const pages = Math.max(1, Math.ceil(total / PAGE_SIZE));
      state.page = Math.min(state.page, pages);
      const start = (state.page - 1) * PAGE_SIZE;
      const count = Math.min(PAGE_SIZE, total - start);
      const diamonds = Array.from({ length: count }, (_, index) => diamondAt(start + index, dimensions));
      q('[data-diamond-count]').textContent = total.toLocaleString();
      q('[data-diamond-results]').innerHTML = diamonds.map(diamond => `
        <button class="ring-builder__diamond-row" type="button" role="row" data-open-diamond='${JSON.stringify(diamond)}'>
          <span class="ring-builder__diamond-name"><img src="${stoneIconUrl(diamond.shape)}" alt=""><b>${diamond.shape}</b></span>
          <span data-label="Carat">${Number(diamond.carat).toFixed(2)} ct</span>
          <span data-label="Color">${diamond.color}</span>
          <span data-label="Clarity">${diamond.clarity}</span>
          <span data-label="Cut">${diamond.cut}</span>
          <span data-label="Origin">${diamond.origin}</span>
          <span data-label="Estimate"><strong>${money(diamond.price)}</strong></span>
          <span aria-hidden="true">→</span>
        </button>`).join('');
      q('[data-page-label]').textContent = `Page ${state.page} of ${pages}`;
      q('[data-page-prev]').disabled = state.page === 1;
      q('[data-page-next]').disabled = state.page === pages;
      q('[data-page-next]').dataset.pages = pages;
    }

    function openDiamond(diamond) {
      state.diamondDraft = diamond;
      q('[data-diamond-detail-image]').src = stoneIconUrl(diamond.shape);
      q('[data-diamond-detail-image]').alt = `${diamond.shape} diamond`;
      q('[data-diamond-detail-name]').textContent = `${Number(diamond.carat).toFixed(2)} ct ${diamond.shape} Diamond`;
      q('[data-diamond-detail-price]').textContent = money(diamond.price);
      q('[data-diamond-specs]').innerHTML = [
        ['Shape', diamond.shape], ['Carat', `${Number(diamond.carat).toFixed(2)} ct`], ['Color', diamond.color],
        ['Clarity', diamond.clarity], ['Cut', diamond.cut], ['Origin', diamond.origin]
      ].map(([label, value]) => `<div><dt>${label}</dt><dd>${value}</dd></div>`).join('');
      setStage('diamond-detail');
    }

    function afterSelection(type) {
      if (state.setting && state.diamond) {
        renderComplete();
        setStage('complete');
      } else if (type === 'setting') {
        state.page = 1;
        renderDiamonds();
        setStage('diamond-catalog');
      } else {
        renderSettings();
        setStage('setting-catalog');
      }
    }

    function renderComplete() {
      const setting = state.setting;
      const diamond = state.diamond;
      const image = q('[data-complete-image]');
      image.dataset.fallback = fallbackUrl(setting.shape, setting.metal);
      image.src = photoUrl(setting.setting, setting.shape, setting.metal);
      image.alt = `${setting.setting.name} in ${setting.metal} with a ${diamond.shape} diamond`;
      if (!image.dataset.boundFallback) {
        attachImageFallback(image);
        image.dataset.boundFallback = 'true';
      }
      const totalText = setting.setting.custom ? `${money(diamond.price)} + custom setting quote` : money(settingPrice(setting) + diamond.price);
      q('[data-summary-total]').textContent = totalText;
      q('[data-summary-setting]').textContent = setting.setting.name;
      q('[data-summary-setting-detail]').textContent = `${setting.metal} · ${setting.shape} center · Size ${setting.size}${setting.setting.settingDiamonds ? ` · ${setting.origin} setting diamonds` : ''} · ${setting.setting.custom ? `Custom request: ${setting.customNotes}` : money(settingPrice(setting))}`;
      q('[data-summary-diamond]').textContent = `${Number(diamond.carat).toFixed(2)} ct ${diamond.shape} diamond`;
      q('[data-summary-diamond-detail]').textContent = `${diamond.color} color · ${diamond.clarity} clarity · ${diamond.cut} cut · ${diamond.origin} · ${money(diamond.price)}`;
      const customRequest = setting.setting.custom ? `; custom setting request: ${setting.customNotes}` : '';
      const message = `Ring builder selections: ${setting.setting.name}; ${setting.metal}; ${setting.shape} center; ring size ${setting.size}; ${Number(diamond.carat).toFixed(2)} ct ${diamond.shape}; ${diamond.color} color; ${diamond.clarity} clarity; ${diamond.cut} cut; ${diamond.origin}${customRequest}; estimated total ${totalText}.`;
      const summaryField = q('[data-ring-summary]');
      if (summaryField) summaryField.value = message;
    }

    CARATS.forEach(carat => q('[data-diamond-filter="carat"]').insertAdjacentHTML('beforeend', `<option value="${carat}">${Number(carat).toFixed(2)} ct</option>`));
    for (let size = 3; size <= 13.001; size += .25) {
      q('[data-ring-size]').insertAdjacentHTML('beforeend', `<option value="${size.toFixed(2)}">${size.toFixed(2)}</option>`);
    }

    qa('[data-path]').forEach(button => button.addEventListener('click', () => start(button.dataset.path)));
    q('[data-start-over]').addEventListener('click', () => {
      state.setting = null; state.diamond = null; state.settingDraft = null; state.diamondDraft = null;
      setStage('landing');
    });
    qa('[data-go-step]').forEach(button => button.addEventListener('click', () => {
      const step = button.dataset.goStep;
      if (step === 'setting') { renderSettings(); setStage('setting-catalog'); }
      if (step === 'diamond') { renderDiamonds(); setStage('diamond-catalog'); }
      if (step === 'complete' && state.setting && state.diamond) { renderComplete(); setStage('complete'); }
    }));

    qa('[data-setting-filter]').forEach(select => select.addEventListener('change', () => {
      state.settingFilters[select.dataset.settingFilter] = select.value;
      renderSettings();
    }));
    q('[data-reset-setting-filters]').addEventListener('click', () => {
      state.settingFilters = { category: 'all', purity: 'all', color: 'all', shape: 'all' };
      qa('[data-setting-filter]').forEach(select => { select.value = 'all'; });
      renderSettings();
    });
    q('[data-setting-grid]').addEventListener('click', event => {
      if (event.target.closest('[data-open-custom-setting]')) { openCustomSetting(); return; }
      const card = event.target.closest('[data-setting-card]');
      if (!card) return;
      const setting = settings.find(item => item.id === card.dataset.settingCard);
      const metal = event.target.closest('[data-metal]');
      const shape = event.target.closest('[data-shape]');
      if (metal) { state.cardChoices[setting.id].metal = metal.dataset.metal; updateCard(card, setting); return; }
      if (shape) { state.cardChoices[setting.id].shape = shape.dataset.shape; updateCard(card, setting); return; }
      if (event.target.closest('[data-open-setting]')) openSetting(setting.id);
    });
    q('[data-back-settings]').addEventListener('click', () => { renderSettings(); setStage('setting-catalog'); });
    q('[data-setting-detail-options="purity"]').addEventListener('click', event => {
      const button = event.target.closest('[data-purity]'); if (!button) return;
      const current = splitMetal(state.settingDraft.metal);
      state.settingDraft.metal = combineMetal(button.dataset.purity, button.dataset.purity === 'Platinum' ? 'White' : current.color);
      state.settingDraft.angle = 0;
      updateSettingDetail();
    });
    q('[data-setting-detail-options="color"]').addEventListener('click', event => {
      const button = event.target.closest('[data-color]'); if (!button) return;
      const current = splitMetal(state.settingDraft.metal);
      state.settingDraft.metal = combineMetal(current.purity, button.dataset.color);
      state.settingDraft.angle = 0;
      updateSettingDetail();
    });
    q('[data-setting-detail-options="shape"]').addEventListener('click', event => {
      const button = event.target.closest('[data-shape]'); if (!button) return;
      state.settingDraft.shape = button.dataset.shape;
      state.settingDraft.angle = 0;
      updateSettingDetail();
    });
    q('[data-setting-thumbnails]').addEventListener('click', event => {
      const button = event.target.closest('[data-angle]'); if (!button) return;
      state.settingDraft.angle = Number(button.dataset.angle);
      updateSettingDetail();
    });
    q('[data-setting-detail-options="origin"]').addEventListener('click', event => {
      const button = event.target.closest('[data-origin]'); if (!button) return;
      state.settingDraft.origin = button.dataset.origin; updateSettingDetail();
    });
    q('[data-ring-size]').addEventListener('change', event => { state.settingDraft.size = event.target.value; });
    q('[data-custom-setting-notes]').addEventListener('input', event => {
      state.settingDraft.customNotes = event.target.value;
      q('[data-custom-setting-notes-error]').hidden = true;
    });
    q('[data-select-setting]').addEventListener('click', () => {
      if (state.settingDraft.setting.custom && !state.settingDraft.customNotes?.trim()) {
        q('[data-custom-setting-notes-error]').hidden = false;
        q('[data-custom-setting-notes]').focus();
        return;
      }
      if (state.settingDraft.setting.custom) state.settingDraft.customNotes = state.settingDraft.customNotes.trim();
      state.setting = { ...state.settingDraft };
      state.cardChoices[state.setting.setting.id] = { shape: state.setting.shape, metal: state.setting.metal };
      afterSelection('setting');
    });

    qa('[data-diamond-filter]').forEach(select => select.addEventListener('change', () => {
      state.diamondFilters[select.dataset.diamondFilter] = select.value;
      state.page = 1; renderDiamonds();
    }));
    q('[data-reset-diamond-filters]').addEventListener('click', () => {
      state.diamondFilters = { origin: 'Lab-Grown', shape: 'all', carat: 'all', color: 'all', clarity: 'all', cut: 'all' };
      qa('[data-diamond-filter]').forEach(select => { select.value = state.diamondFilters[select.dataset.diamondFilter]; });
      state.page = 1; renderDiamonds();
    });
    q('[data-diamond-sort]').addEventListener('change', event => { state.sort = event.target.value; state.page = 1; renderDiamonds(); });
    q('[data-diamond-results]').addEventListener('click', event => {
      const row = event.target.closest('[data-open-diamond]');
      if (row) openDiamond(JSON.parse(row.dataset.openDiamond));
    });
    q('[data-page-prev]').addEventListener('click', () => { if (state.page > 1) { state.page -= 1; renderDiamonds(); } });
    q('[data-page-next]').addEventListener('click', event => { if (state.page < Number(event.currentTarget.dataset.pages)) { state.page += 1; renderDiamonds(); } });
    q('[data-back-diamonds]').addEventListener('click', () => { renderDiamonds(); setStage('diamond-catalog'); });
    q('[data-select-diamond]').addEventListener('click', () => { state.diamond = { ...state.diamondDraft }; afterSelection('diamond'); });
    qa('[data-edit]').forEach(button => button.addEventListener('click', () => {
      if (button.dataset.edit === 'setting') { renderSettings(); setStage('setting-catalog'); }
      else { renderDiamonds(); setStage('diamond-catalog'); }
    }));

    const consultationForm = q('[data-consultation-form]');
    if (consultationForm) {
      consultationForm.addEventListener('submit', () => {
        try {
          sessionStorage.setItem('ta-ring-builder-selection', JSON.stringify({
            setting: state.setting,
            diamond: state.diamond
          }));
        } catch (error) {}
      });
    }

    if (q('[data-consultation-return]')) {
      try {
        const savedSelection = JSON.parse(sessionStorage.getItem('ta-ring-builder-selection') || 'null');
        if (savedSelection?.setting && savedSelection?.diamond) {
          state.setting = savedSelection.setting;
          state.diamond = savedSelection.diamond;
          renderComplete();
          setStage('complete');
          sessionStorage.removeItem('ta-ring-builder-selection');
        }
      } catch (error) {}
    }
  });
})();
